import { BreakpointObserver, MediaMatcher } from "@angular/cdk/layout";
import { Component, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { Subscription } from "rxjs";
import { MatSidenav } from "@angular/material/sidenav";
import { CoreService } from "../../../../../shared/src/lib/services/core.service";
import { navItems } from "./vertical/sidebar/sidebar-data";
import { NgScrollbarModule } from "ngx-scrollbar";
import { AppSearchDialogComponent, HeaderComponent } from "./vertical/header/header.component";
import { AppHorizontalHeaderComponent } from "./horizontal/header/header.component";
import { AppHorizontalSidebarComponent } from "./horizontal/sidebar/sidebar.component";
import { SidebarComponent } from "./vertical/sidebar/sidebar.component";
import { CustomizerComponent } from "./shared/customizer/customizer.component";
import { RouterModule } from "@angular/router";
import { CommonModule } from "@angular/common";
import { AppNavItemComponent } from "./vertical/sidebar/nav-item/nav-item.component";
import { MaterialModule } from "../../material.module";
import { NavService } from "../../../../../shared/src/lib/services/nav.service";
import { AppSettings } from "../../app.config";
import { ApiService } from "../../../../../shared/src/lib/services/api.service";
import { NavItem } from "./vertical/sidebar/nav-item/nav-item";
import { SessionTimeoutService } from "../../../../../shared/src/lib/services/session-timeout.service";

const MOBILE_VIEW = "screen and (max-width: 768px)";
const TABLET_VIEW = "screen and (min-width: 769px) and (max-width: 1024px)";
const MONITOR_VIEW = "screen and (min-width: 1024px)";
const BELOWMONITOR = "screen and (max-width: 1023px)";
@Component({
  selector: "app-full",
  templateUrl: "./full.component.html",
  standalone: true,
  imports: [
    NgScrollbarModule,
    HeaderComponent,
    AppHorizontalHeaderComponent,
    AppHorizontalSidebarComponent,
    SidebarComponent,
    AppSearchDialogComponent,
    CustomizerComponent,
    MaterialModule,
    RouterModule,
    CommonModule,
    AppNavItemComponent,
  ],
  styleUrls: [],
  encapsulation: ViewEncapsulation.None,
})
export class FullComponent implements OnInit {
  navItems = navItems;
  @ViewChild("leftsidenav")
  public sidenav: MatSidenav;
  resView = false;
  //get options from service
  options = this.settings.getOptions();
  navopt = this.navService.showClass;
  private layoutChangesSubscription = Subscription.EMPTY;
  private isMobileScreen = false;
  private isContentWidthFixed = true;
  private isCollapsedWidthFixed = false;
  private htmlElement!: HTMLHtmlElement;

  get isOver(): boolean {
    return this.isMobileScreen;
  }

  get isTablet(): boolean {
    return this.resView;
  }

  constructor(
    private settings: CoreService,
    private mediaMatcher: MediaMatcher,
    private navService: NavService,
    private breakpointObserver: BreakpointObserver,
    private apiService: ApiService,
    private sessionTimeOut: SessionTimeoutService,
  ) {
    this.htmlElement = document.querySelector("html")!;
    this.layoutChangesSubscription = this.breakpointObserver.observe([MOBILE_VIEW, TABLET_VIEW, MONITOR_VIEW, BELOWMONITOR]).subscribe((state) => {
      // SidenavOpened must be reset true when layout changes
      this.options.sidenavOpened = true;
      this.isMobileScreen = state.breakpoints[BELOWMONITOR];

      if (this.options.sidenavCollapsed == false) {
        this.options.sidenavCollapsed = state.breakpoints[TABLET_VIEW];
      }
      this.isContentWidthFixed = state.breakpoints[MONITOR_VIEW];
      this.resView = state.breakpoints[BELOWMONITOR];
    });

    // Initialize project theme with options
    this.receiveOptions(this.options);
  }

  ngOnInit(): void {
    this.validItems();
    this.sessionTimeOut.setupSessionTimeout();
  }

  validItems() {
    let udata = this.apiService.getUserData();
    let role = udata.ROLE;
    let permissions = udata.PERMISSIONS.split(",");
    let items: NavItem[] = [];

    let item = navItems.filter((item) => item.displayName == "Home" || item.displayName == "Dashboard");
    items = [...items, ...item];
    if (permissions.includes("canSetCommission")) {
      let item = navItems.filter((item) => item.displayName == "Commission");
      items = [...items, ...item];
    }
    if (permissions.includes("canSetTakeRisk")) {
      let item = navItems.filter((item) => item.displayName == "Risk Taking");
      items = [...items, ...item];
    }
    if (permissions.includes("canConfigureCountry")) {
      let item = navItems.filter((item) => item.displayName == "Supported Countries");
      items = [...items, ...item];
    }
    if (permissions.includes("canConfigureCurrency")) {
      let item = navItems.filter((item) => item.displayName == "Exchange Rate");
      items = [...items, ...item];
    }
    if (permissions.includes("canConfigureSport")) {
      let item = navItems.filter((item) => item.displayName == "Supported Sports");
      items = [...items, ...item];
    }
    if (permissions.includes("canSetupBetFairAccounts")) {
      let item = navItems.filter((item) => item.displayName == "Betfair Accounts");
      items = [...items, ...item];
    }
    if (permissions.includes("canViewReports")) {
      let item = navItems.filter((item) => item.displayName == "Reports" || item.displayName == "Activity Report");
      items = [...items, ...item];
    }
    if (permissions.includes("canEnableWhiteLabel")) {
      let item = navItems.filter((item) => item.displayName == "White Labels");
      items = [...items, ...item];
    }
    if (permissions.includes("canEnableLiveStream")) {
      let item = navItems.filter((item) => item.displayName == "Live Stream");
      items = [...items, ...item];
    }
    if (permissions.includes("canEnableLiveScore")) {
      let item = navItems.filter((item) => item.displayName == "Live Score");
      items = [...items, ...item];
    }
    if (permissions.includes("canSendNotifications")) {
      let item = navItems.filter((item) => item.displayName == "Notificaions");
      items = [...items, ...item];
    }
    if (permissions.includes("canViewPL")) {
      let item = navItems.filter((item) => item.displayName == "Live PnL");
      items = [...items, ...item];
    }
    if (permissions.includes("canHandleFunds")) {
      let item = navItems.filter(
        (item) =>
          item.navCap == "Funds" ||
          item.displayName == "Deposit" ||
          item.displayName == "Withdraw" ||
          item.displayName == "Transfer" ||
          item.displayName == "Wallets",
      );
      items = [...items, ...item];
    }
    if (role == "super_admin") {
      let item = navItems.filter(
        (item) => item.displayName == "Roles" || item.displayName == "Bet Status" || item.displayName == "Bet Info" || item.displayName == "Betting P/L" || item.displayName == "Payments",
      );
      items = [...items, ...item];
    }
    if (permissions.includes("canViewTransactions") && role !== "super_admin") {
      let item = navItems.filter((item) => item.displayName == "Payments");
      items = [...items, ...item];
    }
    if (permissions.includes("canViewRegistrationReport") && (role === "admin" || role === "super_master")) {
      let item = navItems.filter((item) => item.displayName === "Registered Player Report");
      items = [...items, ...item];
    }
    if (role == "admin" || (role == "operator" && udata.PARENT_ROLE == "admin")) {
      let item = navItems.filter((item) => item.navCap == "Settings");
      items = [...items, ...item];
    }
    if (permissions.includes("enableSupportChannels")) {
      let item = navItems.filter((item) => item.displayName == "Customer Support");
      items = [...items, ...item];
    }

    //set sidnav lists based on permissions
    this.navItems = items;
  }

  ngOnDestroy() {
    this.layoutChangesSubscription.unsubscribe();
    this.navItems = navItems;
  }

  toggleCollapsed() {
    this.isContentWidthFixed = false;
    this.options.sidenavCollapsed = !this.options.sidenavCollapsed;
    this.resetCollapsedState();
  }

  resetCollapsedState(timer = 400) {
    setTimeout(() => this.settings.setOptions(this.options), timer);
  }

  onSidenavClosedStart() {
    this.isContentWidthFixed = false;
  }

  onSidenavOpenedChange(isOpened: boolean) {
    this.isCollapsedWidthFixed = !this.isOver;
    this.options.sidenavOpened = isOpened;
    this.settings.setOptions(this.options);
  }

  receiveOptions(options: AppSettings): void {
    this.options = options;
    this.toggleDarkTheme(options);
  }

  toggleDarkTheme(options: AppSettings) {
    if (options.theme === "dark") {
      this.htmlElement.classList.add("dark-theme");
      this.htmlElement.classList.remove("light-theme");
    } else {
      this.htmlElement.classList.remove("dark-theme");
      this.htmlElement.classList.add("light-theme");
    }
  }
}
